import { subWeeks } from "date-fns";

export const TEXT_FIELDS = [
  "group",
  "installs",
  "trials",
  "converted",
  "rebills",
];

export const COST_FIELDS = [
  "costs",
  "sum",
  "W1",
  "W2",
  "W3",
  "W4",
  "W5",
  "W6",
  "W7",
  "W8",
  "W9",
  "W10",
  "W11",
  "W12",
  "W13",
  "W14",
  "W15",
  "W16",
  "W17",
  "W18",
  "W19",
  "W20",
  "W21",
  "W22",
  "W23",
  "W24",
  "W25",
  "W26",
  "W27",
  "W28",
  "W29",
  "W30",
  "W31",
  "W32",
  "W33",
  "W34",
  "W35",
  "W36",
];

export const REBILLS_TIMEZONES_CHOICES = [
  { id: "+3:00", name: "Default" },
  { id: "+0:00", name: "UTC" },
];

export const REBILLS_TYPE_CHOICES = [
  { id: "all", name: "All" },
  { id: "paid", name: "Paid" },
  { id: "organic", name: "Organic" },
];

const DEFAULT_WEEKS_BACK = 2;

export const DEFAULT_DATE_START = subWeeks(new Date(), DEFAULT_WEEKS_BACK);
export const DEFAULT_DATE_END = new Date();
